export default __webpack_public_path__ + "static/world-58455bfdada9c3a48663b10ee006e96e.svg";